import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const homepageApiSlice = createApi({
  reducerPath: 'homepageApiSlice',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getHomepageData: builder.query({
      query: (params) => ({
        url: 'example/path', // Placeholder URL
        params,
      }),
      providesTags: ['Homepage'],
    }),
  }),
})

export const { useGetHomepageDataQuery } = homepageApiSlice
